import { APIBinderData } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processBillingData = (
  binderReportData: APIBinderData,
): BinderSectionData => {
  const billing = binderReportData?.application_data.billing || {};
  const method_of_payment =
    binderReportData?.application_data.method_of_payment || {};
  const paymentData = binderReportData?.billing_data || {};

  return {
    title: 'Billing',
    description: 'Billing and payment information.',
    isValid: true,
    message: null,
    data: {
      paymentData,
      billing,
      method_of_payment,
    },
  };
};
